// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1yBYf","alert":"SettungsInbox_alert__23CHM"};